import { CurrencyState } from 'src/types/redux';
import { CurrencyActionType, FETCH_CURRENCY_FAILURE, FETCH_CURRENCY_REQUEST, FETCH_CURRENCY_SUCCESS, FETCH_MY_CURRENCY_SUCCESS } from '../types/currencyType';

const initialState: CurrencyState = {
  error: '',
  loading: false,
  currencyData: [],
  myCurrencyData: {
    code: "NPR",
    name: "Nepalese Rupee",
    symbol: "Rs.",
    symbolPosition: "before"
  }
};

export const currencyReducer = (
  state = initialState,
  action: CurrencyActionType
): CurrencyState => {
  switch (action?.type) {
    case FETCH_CURRENCY_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_CURRENCY_SUCCESS:
      return {
        ...state,
        loading: false,
        currencyData: action?.payload,
      };
    case FETCH_CURRENCY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    case FETCH_MY_CURRENCY_SUCCESS:
      return {
        ...state,
        loading: false,
        myCurrencyData: action?.payload,
      };
    default:
      return state;
  }
};
